/* MS Belts 2.0, analytics (architecture section 10). Loaded with defer by layout/theme.liquid, before ms.js.
   API: window.MSTrack.event(name, params). Each event goes to Shopify.analytics.publish, window.dataLayer,
   gtag (when present), Klaviyo (allow-listed events only) and, when the theme setting track_debug is on,
   the console. Personal data is never sent: blocked keys and e-mail or phone-like values are dropped.

   Declarative hooks:
     [data-track="event"]                 fires on click; every data-track-* attribute becomes a param
     <details data-track-open="event">    fires when opened
     <form data-track-submit="event">     marks a pending submission for this tab (sessionStorage)
     [data-track-success="event"]         fires on page load, once per submission (the thank-you render)
     [data-track-view="event"]            fires once when scrolled into view
     [data-track-read-depth="handle"]     fires guide_read_depth at 25, 50, 75 and 100 percent
   Links to another domain also fire outbound_click; untracked mailto:, tel: and WhatsApp links fire
   contact_click. Shopify's standard commerce events are not duplicated here. */
(function () {
  'use strict';

  if (window.MSTrack) return;

  var doc = document;
  var KLAVIYO_EVENTS = { generate_lead: true, sign_up: true, select_build_option: true };
  var HOOK_KEYS = { open: true, submit: true, success: true, view: true, read_depth: true };
  var BLOCKED_KEY = /^(e-?mail|email_address|phone|phone_number|tel|telephone|mobile|whatsapp|name|first_name|last_name|full_name|customer_name|address|street|city|zip|postcode|message|body|note|comment|password)$/i;
  var EMAIL_VALUE = /[^\s@]+@[^\s@]+\.[^\s@]+/;
  var PHONE_VALUE = /^\+?[\d\s().-]{7,}$/;
  var PENDING_PREFIX = 'ms_track_pending:';
  var PENDING_MAX_AGE = 30 * 60 * 1000;

  var debug = false;
  try {
    var configElement = doc.getElementById('ms-config');
    debug = !!(configElement && JSON.parse(configElement.textContent).trackDebug);
  } catch (error) {
    debug = false;
  }

  var store = null;
  try {
    store = window.sessionStorage;
    store.setItem('ms_track_test', '1');
    store.removeItem('ms_track_test');
  } catch (error) {
    store = null;
  }

  function looksLikePhone(value) {
    return PHONE_VALUE.test(value) && /[+\s().-]/.test(value) && value.replace(/\D/g, '').length >= 7;
  }

  function clean(params) {
    var out = {};
    if (!params || typeof params !== 'object') return out;
    Object.keys(params).forEach(function (key) {
      var value = params[key];
      if (BLOCKED_KEY.test(key) || value === undefined || value === null || typeof value === 'function') return;
      if (typeof value === 'string') {
        value = value.replace(/\s+/g, ' ').trim();
        if (EMAIL_VALUE.test(value) || looksLikePhone(value)) return;
        if (value.length > 150) value = value.slice(0, 150);
      }
      out[key] = value;
    });
    return out;
  }

  function merge(target, source) {
    Object.keys(source).forEach(function (key) {
      target[key] = source[key];
    });
    return target;
  }

  function event(name, params) {
    if (!name || typeof name !== 'string') return;
    var data = clean(params);

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (error) { /* Tracking must never break the page. */ }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(merge({ event: name }, data));
    } catch (error) { /* ignore */ }

    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, data);
    } catch (error) { /* ignore */ }

    try {
      var klaviyo = window.klaviyo;
      if (KLAVIYO_EVENTS[name] && klaviyo) {
        if (typeof klaviyo.track === 'function') klaviyo.track(name, data);
        else if (typeof klaviyo.push === 'function') klaviyo.push(['track', name, data]);
      }
    } catch (error) { /* ignore */ }

    if (debug && window.console && typeof window.console.info === 'function') {
      window.console.info('[MSTrack]', name, data);
    }
  }

  window.MSTrack = { event: event };

  /* data-track-collection_handle="x" and data-track-collection-handle="x" both become collection_handle. */
  function paramsFrom(element) {
    var out = {};
    for (var i = 0; i < element.attributes.length; i += 1) {
      var attribute = element.attributes[i];
      if (attribute.name.indexOf('data-track-') !== 0) continue;
      var key = attribute.name.slice(11).replace(/-/g, '_');
      if (!key || HOOK_KEYS[key]) continue;
      out[key] = attribute.value;
    }
    return out;
  }

  function area(element) {
    if (element.closest('.site-footer')) return 'footer';
    if (element.closest('.site-header, .announcement')) return 'header';
    if (element.closest('dialog')) return 'drawer';
    return 'page';
  }

  /* ---------- Clicks ---------- */
  doc.addEventListener('click', function (clickEvent) {
    var target = clickEvent.target;
    if (!target || typeof target.closest !== 'function') return;

    var tracked = target.closest('[data-track]');
    if (tracked) event(tracked.getAttribute('data-track'), paramsFrom(tracked));

    var link = target.closest('a[href]');
    if (!link) return;
    var protocol = (link.protocol || '').toLowerCase();

    if (protocol === 'mailto:' || protocol === 'tel:') {
      if (!tracked) event('contact_click', { method: protocol === 'mailto:' ? 'email' : 'phone', location: area(link) });
      return;
    }
    if ((protocol === 'http:' || protocol === 'https:') && link.hostname && link.hostname !== window.location.hostname) {
      if (!tracked && /(^|\.)(wa\.me|whatsapp\.com)$/i.test(link.hostname)) {
        event('contact_click', { method: 'whatsapp', location: area(link) });
      }
      event('outbound_click', { domain: link.hostname });
    }
  }, true);

  /* ---------- Disclosures (toggle does not bubble, so listen in the capture phase) ---------- */
  /* Browsers also fire toggle for <details open> rendered open, so only count opens after the visitor has
     clicked, tapped or used the keyboard. */
  var visitorActed = false;
  function markActed() { visitorActed = true; }
  doc.addEventListener('pointerdown', markActed, true);
  doc.addEventListener('keydown', markActed, true);

  doc.addEventListener('toggle', function (toggleEvent) {
    var details = toggleEvent.target;
    if (!visitorActed || !details || !details.open || typeof details.getAttribute !== 'function') return;
    var name = details.getAttribute('data-track-open');
    if (!name) return;
    var params = paramsFrom(details);
    if (name === 'faq_open' && !params.question) {
      var summary = details.querySelector('summary');
      if (summary) params.question = summary.textContent;
    }
    if (!params.location) params.location = window.location.pathname;
    event(name, params);
  }, true);

  /* ---------- Forms: remember the submission, report the thank-you render once ---------- */
  function pendingKey(name, form) {
    return PENDING_PREFIX + name + ':' + (form && form.id ? form.id : '');
  }

  doc.addEventListener('submit', function (submitEvent) {
    var form = submitEvent.target;
    if (!store || !form || typeof form.getAttribute !== 'function') return;
    var name = form.getAttribute('data-track-submit');
    if (!name) return;
    try {
      store.setItem(pendingKey(name, form), String(Date.now()));
    } catch (error) { /* ignore */ }
  }, true);

  function reportSuccesses() {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-track-success]'), function (element) {
      var name = element.getAttribute('data-track-success');
      if (!name) return;

      /* With storage available, only a submission made in this tab counts. A reload of the
         thank-you page, or a second form on the page that shows the same message, does not. */
      if (store) {
        var key = pendingKey(name, element.closest('form'));
        var stamp = null;
        try {
          stamp = store.getItem(key);
          store.removeItem(key);
        } catch (error) {
          stamp = null;
        }
        if (!stamp || Date.now() - Number(stamp) > PENDING_MAX_AGE) return;
      }

      var params = paramsFrom(element);
      if (name === 'generate_lead') {
        if (!params.form && element.getAttribute('data-form')) params.form = element.getAttribute('data-form');
        if (!params.topic && element.getAttribute('data-topic')) params.topic = element.getAttribute('data-topic');
      }
      event(name, params);
    });
  }

  /* ---------- Seen on screen ---------- */
  function watchViews() {
    var elements = doc.querySelectorAll('[data-track-view]');
    if (!elements.length || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        event(entry.target.getAttribute('data-track-view'), paramsFrom(entry.target));
      });
    });
    Array.prototype.forEach.call(elements, function (element) {
      observer.observe(element);
    });
  }

  /* ---------- Article read depth ---------- */
  function watchReadDepth() {
    var elements = Array.prototype.slice.call(doc.querySelectorAll('[data-track-read-depth]'));
    if (!elements.length) return;
    var marks = [25, 50, 75, 100];
    var reached = elements.map(function () { return 0; });
    var waiting = false;

    function check() {
      waiting = false;
      var viewport = window.innerHeight || doc.documentElement.clientHeight;
      var done = true;
      elements.forEach(function (element, index) {
        var box = element.getBoundingClientRect();
        if (box.height > 0) {
          var seen = Math.min(1, Math.max(0, (viewport - box.top) / box.height)) * 100;
          while (reached[index] < marks.length && seen >= marks[reached[index]]) {
            event('guide_read_depth', {
              article_handle: element.getAttribute('data-track-read-depth'),
              percent: marks[reached[index]]
            });
            reached[index] += 1;
          }
        }
        if (reached[index] < marks.length) done = false;
      });
      if (done) {
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
      }
    }

    function schedule() {
      if (waiting) return;
      waiting = true;
      window.requestAnimationFrame(check);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    schedule();
  }

  reportSuccesses();
  watchViews();
  watchReadDepth();
})();
